import { Link } from "@gromia/components/Link";
import * as s from "@gromia/components/theme/t.module.css";
import {
  pathToCategoryPage,
  pathToTagPage,
  WpCategoryT,
  WpTagT,
} from "@gromia/utils/models/blog";
import cx from "classnames";
import React from "react";

const cls = cx(
  s.dInlineBlock,
  s.btn,
  s.btnPill,
  s.btnXs,
  s.btnPrimaryLight,
  s.fontSizeSmall2,
  s.fontWeightBold,
);

export function CategoryBadge(props: { category: WpCategoryT }) {
  return (
    <Link to={pathToCategoryPage(props.category)} className={cls}>
      {props.category.name}
    </Link>
  );
}

export function TagBadge(props: { tag: WpTagT }) {
  return (
    <Link to={pathToTagPage(props.tag)} className={cls}>
      {props.tag.name}
    </Link>
  );
}

export function Badge(props: { children: React.ReactNode }) {
  return <span className={cls}>{props.children}</span>;
}
